// Public barrel for the feed engine. Consumers import the `FeedEngine` type and `createFeedEngine`
// from `connector/feed-engine` exactly as before the split into a folder.
import { FeedEngine } from "./feed-engine";
import { AuthFeedEngine } from "./auth-feed-engine";
import { AnonFeedEngine } from "./anon-feed-engine";
import { getMode } from "../auth";

export * from "./feed-engine";
export { AuthFeedEngine } from "./auth-feed-engine";
export { AnonFeedEngine, MAX_ANON_FEEDS, MAX_ANON_SAVED_POSTS, clearAnonData, clearAnonFeedData } from "./anon-feed-engine";

/**
 * Creates the feed engine for the current session: the authenticated engine when a user is logged
 * in, otherwise the anonymous (no-login) engine. Anonymous is the default for a first-time visitor.
 */
export function createFeedEngine(): FeedEngine {
  return getMode() == 'auth' ? new AuthFeedEngine() : new AnonFeedEngine();
}
